/**
 * Text Collapse jQuery Plugin
 * Version 0.1  (16/06/2009)
 * Author: Simon Dyson
 * requires jQuery v1.2.x+
 *
 * Usage:
 *
 *   $('#mydiv').textcollapse(); // Autofit mydiv's innerHTML content horizontally and add 'read more' button to view full text
 *
 * Based on jquery.abbreviator.js and jquery.expander.js.
 *
 */

(function($)
{
    $(function()
    {
        // NOTE: We have to use a <span> inside a max-width <div> for IE6
        $('body').append('<div id="abbreviator-tmp-div" style="width:9999px; left:-9999px; top:-9999px; display:block; position: absolute">' +
				'<span id="abbreviator-tmp-span"></span>' +
			'</div>'
                );
    });

    $.fn.textcollapse = function(options)
    {

        var opts = $.extend({}, $.fn.textcollapse.defaults, options);
        var delayedCollapse;
        $(this).each(function()
        {
            var $this = $(this);
            var o = $.meta ? $.extend({}, opts, $this.data()) : opts;

            // Grab unaltered content FIRST
            var content;
            if($this.find(".read-more").size()==0) {
                content = $this.html();
            }
            else { // already collapsed so we are responding to a request recalculate the abbreviation point. 
                content = $this.find(".summary").html() + $this.find(".details").html();
            }

            // Append our tmp div to the container element we're about
            // to abbreviate, so that it inherits the containers CSS properties
            // (font, padding, etc.)
            $("#abbreviator-tmp-div").appendTo(this);
            var containerWidth;
            if(!o.parentIsContainer)
            {
                containerWidth = $this.width();
            }
            else
            {
                containerWidth = $this.parent().width();
            }

            $this.siblings(".abbreviate-deduction").each(function()
            {
                containerWidth = containerWidth - $(this).outerWidth(true);
            });
            if(o.extraGap > 0) {
                containerWidth = containerWidth - o.extraGap;
            }

            var contentWidth = $("#abbreviator-tmp-span").html(content).width();

            // If the content fits inside the container, then skip
            // to the next element

            if(contentWidth <= containerWidth)
            {
                $('#abbreviator-tmp-div').appendTo('body');
                return;
            }

            // Instead of just removing characters one-by-one until the content
            // fits (slow), we estimate a good starting place by taking the %
            // covered in pixel space and shorten the string by that amount.

            var coverage = containerWidth / contentWidth;
            var l = content.length;

            var abbrevContent = content.substr(0, parseInt(l * coverage));

            while($('#abbreviator-tmp-span').html(ellipsifyString(abbrevContent, o)).width() >= containerWidth && abbrevContent.length > 0)
            {
                abbrevContent = abbrevContent.substring(0, abbrevContent.length - 1);
            }

            // Return our tmp span back to the <body> element; otherwise it'll
            // be destroyed in the line below ...
            $('#abbreviator-tmp-div').appendTo('body');

            var summary = $('<span class="summary">' + abbrevContent + '</span>');
            var readMore = $('<span class="read-more">' + o.expandPrefix + '<a href="#">' + o.expandText + '</a></span>');
            var details = $('<span class="details">' + content.substring(abbrevContent.length) + '</span>');
            $this.html(summary).append(readMore).append(details);

            details.hide();
            readMore.find('a').click(function()
            {
                readMore.hide();

                if(o.expandEffect === 'show' && !o.expandSpeed)
                {
                    o.beforeExpand($this);
                    details.show();
                    o.afterExpand($this);
                    delayCollapse(o, details);
                }
                else
                {
                    o.beforeExpand($this);
                    details[o.expandEffect](o.expandSpeed, function()
                    {
                        details.css({zoom: ''});
                        o.afterExpand($this);
                        delayCollapse(o, details);
                    });
                }
                return false;
            });
            if(o.userCollapse)
            {
                $this.find('span.details').append('<span class="re-collapse">' + o.userCollapsePrefix + '<a href="#">' + o.userCollapseText + '</a></span>');
                $this.find('span.re-collapse a').click(function()
                {

                    clearTimeout(delayedCollapse);
                    var $detailsCollapsed = $(this).closest('span.details');
                    reCollapse($detailsCollapsed);
                    o.onCollapse($this, true);
                    return false;
                });
            }
        });
    }

    // Private functions

    function ellipsifyString(s, options)
    {
        return s + options.expandPrefix + " " + options.expandText;
    }

    function reCollapse(el)
    {
        el.hide()
                .prev('span.read-more').show();
    }

    function delayCollapse(option, $collapseEl)
    {
        if(option.collapseTimer)
        {
            delayedCollapse = setTimeout(function()
            {
                reCollapse($collapseEl);
                option.onCollapse($collapseEl.parent(), false);
            },
                    option.collapseTimer
                    );
        }
    }

    // plugin defaults
    $.fn.textcollapse.defaults = {
        expandText:       'Weiterlesen', // text displayed in a link instead of the hidden part of the element.
        expandPrefix:     '&hellip; ',
        collapseTimer:    0, // number of milliseconds after text has been expanded at which to collapse the text again
        expandEffect:     'fadeIn',
        expandSpeed:      '',   // speed in milliseconds of the animation effect for expanding the text
        userCollapse:     true, // allow the user to re-collapse the expanded text.
        userCollapseText: 'Weniger lesen',  // text to use for the link to re-collapse the text
        userCollapsePrefix: '&nbsp;',
        parentIsContainer: false,
        extraGap:          0, // Extra number of pixels to leave clear after the collapsed text
        beforeExpand: function($thisEl){},
        afterExpand: function($thisEl){},
        onCollapse: function($thisEl, byUser){}
    };
})(jQuery);